import { useGetCommercePaymentsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetCommercePaymentsQuery as usePreviewGetCommercePaymentsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { getPreviewState } from '../utils/getPreviewState';
export function useCommercePaymentsData(variables) {
  const previewState = getPreviewState();
  const previewJwt = previewState.isPreview ? previewState.previewJwt : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetCommercePaymentsQuery({
    variables: Object.assign({
      previewJwt
    }, variables),
    skip: !previewState.isPreview
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useGetCommercePaymentsQuery({
    variables,
    skip: previewState.isPreview
  });
  if (previewState.isPreview) {
    return {
      loading: previewLoading,
      error: previewError,
      data: previewData
    };
  }
  return {
    loading,
    error,
    data: data !== null && data !== void 0 ? data : previousData === null || previousData === void 0 ? void 0 : previousData.result
  };
}